import { format, isSameDay } from "date-fns";
import { useCallback, useMemo, useState } from "react";

import { SlotFragment } from "~/graphql";

type Option = {
  value: string;
  startTime: string;
  endTime: string;
};

export const useAvailableReservation = (slots: SlotFragment[]) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const filterDays = useMemo(() => {
    const days = new Set<string>();
    for (const slot of slots) {
      days.add(slot.date);
    }
    return Array.from(days).map((day) => new Date(day));
  }, [slots]);
  const isSelectableDate = filterDays.length > 0;
  const timeOptions: Option[] = useMemo(() => {
    if (!selectedDate) return [];

    const openingHours = slots.filter(({ date }) =>
      isSameDay(new Date(date), selectedDate),
    );

    return openingHours.map(({ startAt, endAt }) => {
      const startTime = format(new Date(startAt), "HH:mm");
      const formattedEndAt = format(new Date(endAt), "HH:mm");
      // 予約枠の終了時間が24:00の場合は終了時間0:00（翌日）として返却してしまう
      // そのまま予約を試みるとサーバー側で開始時間と終了時間が逆転しているとみなされ保存に失敗してしまう
      // よって、受付時間の終了時間が24:00の場合は明示的に24:00を格納する
      const endTime = formattedEndAt === "00:00" ? "24:00" : formattedEndAt;

      return {
        startTime,
        endTime,
        value: `${startTime} - ${endTime}`,
      };
    });
  }, [selectedDate, slots]);

  const handleSelectDate = useCallback((_date: Date) => {
    setSelectedDate(_date);
  }, []);
  const handleFilter = useCallback(
    (date: Date) => filterDays.some((_date) => isSameDay(_date, date)),
    [filterDays],
  );

  return {
    isSelectableDate,
    timeOptions,
    handleFilter,
    handleSelectDate,
  };
};
